import React, { useState } from "react";
import {
  BgImagesCarousel,
  type ImageCarouselAttribute,
} from "./bgImagesCarousel";
import { type CardCarouselAttribute, CardsCarousel } from "./CardsCarousel";

interface SynchronizedCarouselsProps {
  bannerPageCard: ImageCarouselAttribute[];
  ldPageCard: CardCarouselAttribute[];
  isLogin: boolean;
  t: (key: string) => string;
  /**
   * Hide the bottom `CardsCarousel` while keeping the top `BgImagesCarousel`.
   *
   * Default `false` so existing V1 behavior is unchanged. Pass `true` only
   * from V2 (`homePageContainerV2`) per CX-2283 — V2 reuses the banner
   * carousel but does not need the synchronized cards section.
   */
  hideCardsCarousel?: boolean;
}

export const SynchronizedCarousels: React.FC<SynchronizedCarouselsProps> =
  React.memo(
    ({ bannerPageCard, ldPageCard, isLogin, t, hideCardsCarousel = false }) => {
      const [slideIndex, setSlideIndex] = useState<number>(0);

      return (
        <>
          <BgImagesCarousel
            t={t}
            images={bannerPageCard}
            onChangeIndex={setSlideIndex}
          />
          {!hideCardsCarousel && (
            <CardsCarousel
              t={t}
              isLogin={isLogin}
              cards={ldPageCard}
              goToSlide={slideIndex}
            />
          )}
        </>
      );
    },
  );
